import { useList } from '@refinedev/core';

import { UnifiedMitigationType } from './../types';

export const useUnifiedMitigationTypes = () => {
  const migratedUnifiedMitigationTypesQuery = useList<UnifiedMitigationType>({
    resource: 'unified_mitigation_types',
    pagination: { pageSize: 10000 }
  });

  const unifiedMitigationTypesQuery = {
    ...migratedUnifiedMitigationTypesQuery.result,
    ...migratedUnifiedMitigationTypesQuery.query,
    ...migratedUnifiedMitigationTypesQuery
  };

  return { unifiedMitigationTypesQuery };
};
